/**
 * LUNE — Analytics (vanilla JS, aucun outil tiers).
 * Pousse des événements propres vers window.dataLayer pour une mesure future
 * (GA4/serveur/etc.), sans dépendance ni appel réseau ajouté par LUNE elle-même.
 */
window.Lune = window.Lune || {};

Lune.Analytics = (function () {
  'use strict';

  var EVENTS = {
    OPEN: 'lune_open',
    START_RECOMMENDATION: 'lune_start_recommendation',
    ROOM_SELECTED: 'lune_room_selected',
    STYLE_SELECTED: 'lune_style_selected',
    COLOR_SELECTED: 'lune_color_selected',
    INTENSITY_SELECTED: 'lune_intensity_selected',
    RESULTS_DISPLAYED: 'lune_results_displayed',
    PRODUCT_CLICKED: 'lune_product_clicked',
    MATERIAL_CLICKED: 'lune_material_clicked',
    PREMIUM_RECOMMENDED: 'lune_premium_recommended',
    PWP_CLICKED: 'lune_pwp_clicked',
    QUESTION: 'lune_question',
    NO_ANSWER: 'lune_no_answer'
  };

  function track(eventName, detail) {
    try {
      var payload = { event: eventName };
      if (detail) {
        for (var k in detail) {
          if (detail.hasOwnProperty(k)) payload[k] = detail[k];
        }
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {
      /* jamais bloquer la conversation pour un souci d'analytics */
    }
  }

  return { EVENTS: EVENTS, track: track };
})();